/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Lineas from "./Componentes/Home_Lineas";
import Home_Catalogo from "./Componentes/Home_Catalogo";
import Home_Indicadores from "./Componentes/Home_Indicadores";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Nosotros_Home from "./Componentes/Nosotros_Home";

const Seccion_Home = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -13.5}}>
                <Home_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Lineas/>
            </Grid>

            <Grid id={'catalogo'} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Home_Catalogo/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Home_Indicadores/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Home_Testimonios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Nosotros_Home/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Home    